export default {
    shipperGroup: {
        overview: "Resumen e IA",
        operations: "Operaciones",
        coordination: "Bandeja e incidencias",
        commercial: "Comercial",
        network: "Contactos y red",
    },
    askEve: "Pregunta a Eve",
    askEveHelpPopover: "¿Necesitas ayuda?",
    askEveHelpDismiss: "Cerrar",
    controlHub: "Centro de Control",
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Contenedor",
    activity: "Actividad",
    issues: "Incidencias",
    quotes: "Cotizaciones",
    orders: "Pedidos",
    receivers: "Socios Comerciales",
    businessPartners: "Socios Comerciales",
    shippers: "Expedidores",
    team: "Equipo",
    addressBook: "Libreta de Direcciones",
    settings: "Configuración",
    companies: "Empresas",
    support: "Soporte",
    logout: "Cerrar sesión",
    documents: "Documentos",
    eveDrive: "Eve Drive",
    liveTracking: "Seguimiento en vivo",
    workflows: "Flujos de Trabajo",
    knowledgeBase: "Base de Conocimiento",
    analytics: "Analytics",
    reviewCenter: "Centro de Revisiones",
    unreadNotifications: "{{count}} notificaciones no leídas",
};
